module.exports = __webpack_public_path__ + "img/9.0a4e704b.png";